import React, { useState } from "react";
import { CARD_STYLE } from "../constants/styles";
import { DEFAULT_BLUE_GRADIENT } from "../constants/styles";

export default function DashboardToolPanel({ title, actions }) {

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(null);

  const toolPanel = {
    display: "flex",
    width: "300px",
    flexDirection: "column",
    paddingBottom: "16px",
    marginLeft: "0px",

    // 🔥 DARK PANEL
    background: "linear-gradient(180deg, #2b2f35 0%, #1f2329 100%)",
	border: "1px solid #dde3e8",

		boxShadow:
		    "0 4px 12px rgba(0,0,0,0.06)",

    color: "#ffffff",
    borderRadius: "10px",
	alignSelf: "flex-start"
  };

  const toolTitle = {

      //position: "absolute",

     margin:'10px',
	 //width:'calc(100% - 20px)',

      padding: "8px 20px",

      borderRadius: "18px",

      background:
          "rgba(255,255,255,0.92)",

      backdropFilter: "blur(8px)",

      border:
          "1px solid rgba(0,0,0,0.04)",

      boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

      fontSize: "12px",

      fontWeight: "600",

      color: "#1f2937",

      zIndex: 2

  };

  const pillContainer = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "0 12px"
  };

  const getPillStyle = (active, hovered) => {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "32px",
      borderRadius: "16px",

      fontSize: "12px",
      fontWeight: active ? "600" : "500",
      letterSpacing: "0.3px",

      cursor: "pointer",
      userSelect: "none",

      transition: "all 0.2s ease",

      // 🔥 BACKGROUND STATES
      background: active
        ? DEFAULT_BLUE_GRADIENT
        : hovered
          ? "rgba(255,255,255,0.12)"
          : "rgba(255,255,255,0.06)",

      // 🔥 TEXT
      color: active
        ? "#ffffff"
        : "#9ca3af",

      // 🔥 BORDER
      border: active
        ? "1px solid rgba(255,255,255,0.35)"
        : "1px solid rgba(255,255,255,0.08)",

      // 🔥 DEPTH + GLOW
      boxShadow: active
        ? "0 4px 12px rgba(59,130,246,0.4)"
        : hovered
          ? "0 4px 10px rgba(0,0,0,0.25)"
          : "inset 0 1px 0 rgba(255,255,255,0.05)",

      transform: hovered ? "translateY(-1px)" : "none"
    };
  };

  const handleClick = (index, actionFunction) => {
    setSelectedIndex(index);
    if (actionFunction) {
      actionFunction();
    }
  };

  const actionDisplay = actions.map((item, index) => (
    <div
      key={index}
      style={getPillStyle(index === selectedIndex, index === hoverIndex)}
      onMouseEnter={() => setHoverIndex(index)}
      onMouseLeave={() => setHoverIndex(null)}
      onClick={() => handleClick(index, item.actionFunction)}
    >
      {item.label}
    </div>
  ));

  return (
    <div style={{ ...toolPanel, ...CARD_STYLE }}>
      <div style={toolTitle}>
        {title}
      </div>

      <div style={pillContainer}>
        {actionDisplay}
      </div>
    </div>
  );
}